<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>

    <div class="l-contents">

      <h1 class="l-pageTitle"><span class="l-pageLabel">法人情報</span>法人情報CSVアップロード（一括新規作成）</h1>

      <div v-if="this.isCheckManagedCorpCount">
        <!--div class="l-contentsBox"-->
          <div class="caution-block">
            <p class="caution-block__title">登録可能な企業の上限に達しています。</p>
            <div class="caution-block__body">
              <p>現在のプランで登録できる顧問先数は最大{{this.usagePlanList[this.usagePlanId].maxCount}}社です。</p>
              <p v-if="this.usagePlanId==2">スタンダードプラン利用者の場合は最大{{this.usagePlanList[1].maxCount}}社まで登録可能です。<br>
                アップグレードをお希望の場合は診断協会までお問い合わせください。<br>
                <a href="mailto:contact@roumu-kansa.jp">contact@roumu-kansa.jp</a>
              </p>
            </div>
          </div>
        <!--/div-->
      </div>
      <!-- isCheckManagedCorpCount -->

      <div v-else>
        <p class="l-text">法人情報のCSVファイルをアップロードしてください。表示確認後、取り込みボタンを押下すると新規作成されます。</p>
        <div class="u-mt20">
          <div class="btn-download"><a href="../corporate_list.csv">CSVフォーマットのダウンロード</a></div>
        </div>

        <div class="u-mt20">
          <h3 class="l-headding is-blueline">CSV入力例</h3>
          <table class="table-base csv-table">
            <colgroup>
              <col>
              <col>
              <col style="width: 130px;">
              <col style="width: 110px;">
              <col style="width: 110px;">
              <col style="width: 150px;">
              <col>
              <col style="width: 120px;">
              <col style="width: 100px;">
            </colgroup>
            <thead>
              <tr>
                <th>法人名<span class="label-required-text">必須</span></th>
                <th>法人名（ヨミガナ）<span class="label-required-text">必須</span></th>
                <th>代表電話番号<span class="label-required-text">必須</span></th>
                <th>郵便番号<span class="label-required-text">必須</span></th>
                <th>都道府県<span class="label-required-text">必須</span></th>
                <th>市区町村・番地<span class="label-required-text">必須</span></th>
                <th>建物名・部屋番号など</th>
                <th>顧問先番号</th>
                <th>担当者</th>
              </tr>
            </thead>
            <tr>
              <td>株式会社ヨクスル</td>
              <td>カブシキガイシャヨクスル</td>
              <td>090-1111-2222</td>
              <td>6068227</td>
              <td>広島県</td>
              <td>広島市中区中町7-41</td>
              <td>広島三栄ビル8F</td>
              <td>A-a_123456</td>
              <td>労務太郎</td>
            </tr>
            <tbody>
            </tbody>
          </table>
        </div>
        <div class="l-pinkBox">
          <ul class="notice-list">
            <li>都道府県名は「県」や「府」まで入力してください。　◯広島県　×広島</li>
            <li>代表電話番号は半角数字でハイフンをつけて入力してください。　◯090-1111-2222　×09011112222</li>
            <li>顧問先番号は10文字までの半角英数字および「-」「_」を入力してください。　◯Ab123　×yokusuru123451　×a1!</li>
          </ul>
        </div>

        <div v-if="this.isCheckManagedCorpCountAfterReading">
          <!--div class="l-contentsBox"-->
            <div class="caution-block">
              <p class="caution-block__title">登録可能な企業の上限に達しています。</p>
              <div class="caution-block__body">
                <p>現在のプランで登録できる顧問先数は最大{{this.usagePlanList[this.usagePlanId].maxCount}}社です。</p>
                <p v-if="this.usagePlanId==2">スタンダードプラン利用者の場合は最大{{this.usagePlanList[1].maxCount}}社まで登録可能です。<br>
                  アップグレードをお希望の場合は診断協会までお問い合わせください。<br>
                  <a href="mailto:contact@roumu-kansa.jp">contact@roumu-kansa.jp</a>
                </p>
              </div>
            </div>
          <!--/div-->
        </div>
        <!-- isCheckManagedCorpCountAfterReading -->

        <div class="l-grayBox u-mt30 u-mb40">
          <div class="l-fileinput">
            <input type="file" @change="fileSelected" id="loader" name="csvFile">
          </div>
        </div>
        <div v-show="inputCsvListShow">

          <h3 class="l-headding is-blueline">取り込み対象</h3>
          <table class="table-base csv-table">
            <colgroup>
              <col>
              <col>
              <col style="width:130px;">
              <col style="width:110px;">
              <col style="width:110px;">
              <col style="width:150px;">
              <col>
              <col style="width:120px;">
              <col style="width:100px;">
            </colgroup>
            <thead>
              <tr>
                <th>法人名</th>
                <th>法人名（ヨミガナ）</th>
                <th>代表電話番号</th>
                <th>郵便番号</th>
                <th>都道府県</th>
                <th>市区町村・番地</th>
                <th>建物名・部屋番号など</th>
                <th>顧問先番号</th>
                <th>担当者</th>
              </tr>
            </thead>
            <tbody>

              <tr v-for="(corporate,key) in corporateList" :key="key">
                <td>{{ corporate["法人名"] }}</td>
                <td>{{ corporate["法人名（ヨミガナ）"] }}</td>
                <td>{{ corporate["代表電話番号"] }}</td>
                <td>{{ corporate["郵便番号"] }}</td>
                <td>{{ corporate["都道府県"] }}</td>
                <td>{{ corporate["市区町村・番地"] }}</td>
                <td>{{ corporate["建物名・部屋番号など"] }}</td>
                <td>{{ corporate["顧問先番号"] }}</td>
                <td>{{ corporate["担当者"] }}</td>
              </tr>

            </tbody>
          </table>
          <div class="l-contentsBox__bottom" style="text-align: center;" v-if="!this.isCheckManagedCorpCountAfterReading">
            <div class="btn-basic is-inlne is-wide is-primary" @click="register()" :disabled="isProcessing"><a >上記を取り込む（新規作成）</a></div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

import Loading from '@/components/parts/common/Loading.vue';

export default {
  name: 'CorporateList',
  components: {
    Loading,
  },
  data() {
    return {
      userCorporate: null,
      pageInfo: {},
      corporateList: [],
      corporatePlanOptionList: [],
      isProcessing: false,
      isSystemAdmin: false,
      isAllPermission: false,
      isAdmin: false,
      files: '',
      inputCsvListShow: false,
      usagePlanList: [
        {
          value: null,
          label: '',
          maxCount: null,
        }
      ],
      isCheckManagedCorpCountAfterReading: false,
      isCheckManagedCorpCount: false,
      planId: null,
      usagePlanId: null,
      managedCorpCount: null,
    }
  },
/*  computed: {
    // 登録企業数チェック権限(遷移時)
    isCheckManagedCorpCount(){
      if ( this.planId != 4 || this.usagePlanId == null) return false;
      return this.planId == 4 && this.isAdmin && (this.usagePlanList[this.usagePlanId]!= null) && (this.managedCorpCount>=this.usagePlanList[this.usagePlanId].maxCount);
    },
  },*/
  created: async function(){
    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isAdmin = authority.isAdmin;
    this.userCorporate=authority.corporate;
    this.planId = authority.planId;
    this.usagePlanId = authority.usagePlanId;
    this.managedCorpCount = authority.managedCorpCount;

    await this.getUsagePlanList();
    this.isProcessing = false;
  },
  methods: {
    async getUsagePlanList() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/contact/trial_entry/getUsagePlanList');
      if (res) {
        let usagePlanList = [];
        res.data.usagePlanList.forEach(u => {
          usagePlanList.push({
            value: u.usagePlanId,
            label: u.name,
            maxCount: u.maxCount,
          });
        });
        this.usagePlanList = usagePlanList;
        
        if ( this.planId != 4 || this.usagePlanId == null) {
          this.isCheckManagedCorpCount = false;
        }else {
          this.isCheckManagedCorpCount = this.planId == 4 && this.isAdmin && (this.usagePlanList[this.usagePlanId]!= null) && (this.managedCorpCount>=this.usagePlanList[this.usagePlanId].maxCount);
        }

//        this.isCheckManagedCorpCount = this.planId == 4 && this.isAdmin && (this.managedCorpCount>=this.usagePlanList[this.usagePlanId].maxCount);
      }
      this.isProcessing = false;
    },
    async fileSelected(event) {

      this.inputCsvListShow=true;

      const input = document.getElementById('loader');
      input.addEventListener('click', (e) => {
        e.target.value = '';
      });

      this.fileInfo = event.target.files[0];

      this.corporateList=[];
      this.isProcessing = true;

      const formData = new FormData()
      formData.append('csvFile', this.fileInfo)
      let res = await this.$axios.post('/ld/api/corporate/csvupload', formData);
      if (res.status === 200) {
        this.corporateList = res.data.corporateList;
        this.isCheckManagedCorpCountAfterReading = (this.planId == 4 && this.isAdmin && (res.data.managedCorpCount+this.corporateList.length>this.usagePlanList[this.usagePlanId].maxCount));
      }else{
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },

    async register() {
      this.isProcessing = true;

      const formData = new FormData()
      formData.append('corporateList', JSON.stringify(this.corporateList))
      let res = await this.$axios.post('/ld/api/corporate/csvstore', formData);
      if (res.status === 200) {
        this.$toast.info('登録が完了しました');
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
  }
}
</script>
